import styled from "styled-components";
import { IconDelete, IconEdit, IconMapPin } from "../../config/icons";
import { useState } from "react";
import { Popconfirm } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";
import { useTranslation } from "react-i18next";

const IconButtonDefaultStyled = styled.div`
  font-size: 1.4em;
  color: #888;
  cursor: pointer;
  border-radius: 10em;

  width: 1.6em;
  height: 1.6em;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #fff;
    background-color: #40a9ff;
  }
`;

const IconButtonDangerStyled = styled.div`
  font-size: 1.4em;
  color: red;
  cursor: pointer;
  border-radius: 10em;

  width: 1.6em;
  height: 1.6em;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #fff;
    background-color: red;
  }
`;

interface IconButtonProps {
  onClick: () => void;
}

export const EditIconButton = (props: IconButtonProps) => (
  <IconButtonDefaultStyled
    onClick={props.onClick}
    data-testid="icon-button-edit"
  >
    <IconEdit dataTestid="icon-button-edit-svg" />
  </IconButtonDefaultStyled>
);

export const FilterMapIconButton = (props: IconButtonProps) => (
  <IconButtonDefaultStyled
    onClick={props.onClick}
    data-testid="icon-button-map"
  >
    <IconMapPin />
  </IconButtonDefaultStyled>
);

export const DeleteIconButton = (props: IconButtonProps) => (
  <IconButtonDangerStyled
    onClick={props.onClick}
    data-testid="icon-button-delete"
  >
    <IconDelete dataTestid="icon-button-delete-svg" />
  </IconButtonDangerStyled>
);

const IconButtonWithConfirmWrapper = styled.div`
  // flex-grow: 0;
  // flex-shrink: 0;

  // margin-top: auto;
  // margin-bottom: 0;
  // margin-right: auto;

  // height: 32px;

  display: flex;
  justify-content: center;

  align-content: ;
  font-size: 1.4em;

  width: min-content;
  margin: auto 0.3em;
  cursor: pointer;

  svg {
    margin: auto;
  }

  &.disabled {
    color: rgb(217, 217, 217);
    cursor: not-allowed;
  }
`;

interface IIconButtonWithConfirmProps {
  popconfirmOption: {
    title: string;
    placement?: TooltipPlacement | undefined;
  };
  children: React.ReactNode;
  onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
}

export const IconButtonWithConfirm = ({
  popconfirmOption,
  children,
  onClick,
}: IIconButtonWithConfirmProps) => {
  const { t } = useTranslation();

  const { title, placement = "top" } = popconfirmOption;

  const [popConfirm, setPopConfirm] = useState<boolean>(false);

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      setPopConfirm(newOpen);

      return;
    }
  };

  return onClick ? (
    <Popconfirm
      placement={placement}
      icon={null}
      open={popConfirm}
      onOpenChange={handleOpenChange}
      title={title}
      onConfirm={onClick}
      onCancel={(event) => {
        setPopConfirm(false);
        event?.stopPropagation();
      }}
      okText={t("switch-yes")!}
      cancelText={t("switch-no")!}
      onPopupClick={(event) => event?.stopPropagation()}
    >
      <IconButtonWithConfirmWrapper
        className="icon-button"
        onClick={(event) => {
          setPopConfirm(true);
          event.stopPropagation();
        }}
      >
        {children}
      </IconButtonWithConfirmWrapper>
    </Popconfirm>
  ) : (
    <IconButtonWithConfirmWrapper
      className="icon-button disabled"
      onClick={(event) => {
        setPopConfirm(true);
        event.stopPropagation();
      }}
    >
      {children}
    </IconButtonWithConfirmWrapper>
  );
};
